<template>
  <div>
    <div class="w-full flex items-center mt-4 px-8">
      <SurveyWizardStep to="/survey/shop-info">
        <LibraryIcon class="h-5 w-5"/>
      </SurveyWizardStep>

      <hr class="flex-1 h-2">

      <SurveyWizardStep to="/survey/product-survey">
        <ClipboardListIcon class="h-5 w-5"/>
      </SurveyWizardStep>

      <hr class="flex-1 h-2">
      <SurveyWizardStep to="/survey/questionnaire">
        <DocumentTextIcon class="h-5 w-5"/>
      </SurveyWizardStep>

      <hr class="flex-1 h-2">

      <SurveyWizardStep to="/survey/competitor-analyze">
        <ChartPieIcon class="h-5 w-5"/>
      </SurveyWizardStep>

      <hr class="flex-1 h-2">

      <SurveyWizardStep to="/survey/details">
        <ArchiveIcon class="h-5 w-5"/>
      </SurveyWizardStep>
    </div>

    <router-view></router-view>

    <!--    <Button class="absolute w-5/6 left-0 right-0 mx-auto bottom-24">ادامه</Button>-->
  </div>
</template>

<script>
import {ArchiveIcon, ChartPieIcon, ClipboardListIcon, LibraryIcon,DocumentTextIcon} from "@heroicons/vue/outline";
import SurveyWizardStep from "../../components/SurveyWizardStep";

export default {
  name: "Survey",
  components: {SurveyWizardStep, LibraryIcon, ClipboardListIcon, ArchiveIcon, ChartPieIcon,DocumentTextIcon},
}
</script>

<style scoped>

</style>